import { Link } from "react-router-dom";
import type { SkinConcernTag } from "@/mocks/skinTreatments";

/** 未確定の医療情報を、後から入力できるプレースホルダーとして表示するパネル */
export function PlaceholderPanel({ label, note }: { label: string; note: string }) {
  return (
    <div className="border border-dashed border-foreground-950/20 bg-background-100/50 p-8 md:p-10">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-full border border-foreground-950/15 text-foreground-500">
          <i className="ri-file-edit-line" aria-hidden />
        </span>
        <span className="en-eyebrow text-[10px] text-secondary-700 md:text-[11px]">{label}</span>
      </div>
      <p className="mt-5 max-w-2xl text-[13px] leading-[2.1] text-foreground-600">{note}</p>
    </div>
  );
}

/** 後から文章を差し込める空スロット（見出し・本文の枠のみ用意） */
export function PlaceholderSlots({ count, columns }: { count: number; columns: string }) {
  return (
    <div className={`grid grid-cols-1 gap-px border border-foreground-950/12 bg-foreground-950/12 ${columns}`}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="bg-background-50 p-7">
          <span className="font-label text-[12px] tracking-[0.25em] text-secondary-600">
            {String(index + 1).padStart(2, "0")}
          </span>
          <div className="mt-5 space-y-2.5" aria-hidden>
            <span className="block h-3 w-2/3 rounded-sm bg-foreground-950/10" />
            <span className="block h-2.5 w-full rounded-sm bg-foreground-950/5" />
            <span className="block h-2.5 w-4/5 rounded-sm bg-foreground-950/5" />
          </div>
        </div>
      ))}
    </div>
  );
}

/** この施術をご案内しているお悩み（お肌管理ページの該当項目へ戻れるリンク） */
export function SkinConcernLinks({ items }: { items: SkinConcernTag[] }) {
  return (
    <div className="flex flex-wrap gap-3">
      {items.map((item) => (
        <Link
          key={item.target}
          to={`/treatment/skin-management#${item.target}`}
          className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-[13px] text-foreground-800 transition-colors hover:border-accent-400 hover:bg-secondary-100/70 hover:text-foreground-950"
        >
          <i className="ri-search-line text-sm text-foreground-500 transition-colors group-hover:text-accent-700" aria-hidden />
          {item.label}
          <i
            className="ri-arrow-right-line text-[13px] text-foreground-400 transition-transform group-hover:translate-x-0.5"
            aria-hidden
          />
        </Link>
      ))}
    </div>
  );
}